import * as React from "react";

import { ServiceAccount } from '../../../../models/ServiceAccount';
import { DataGrid, Getter } from '../../../../components/DataGrid/DataGrid';
import { DataGridTextColumn } from '../../../../components/DataGrid/DataGridTextColumn';
import { DataGridButtonColumn } from '../Columns/DataGridButtonColumn';
import { DataGridTemplateColumn, Props as TemplateProps } from "../../../../components/DataGrid/DataGridTemplateColumn";
import { IdColumn } from "../Columns/IdColumn";
import { MultiselectColumn, multiselectPropsFrom, MultiselectProps } from "../Columns/MultiselectColumn";
import { Polyglot } from "../../../../polyglot";

interface ServiceAccountGridProps extends MultiselectProps
{
    polyglot: Polyglot;
    isAdmin: boolean;
    isDivisionAware: boolean;
    onEdit: (datum: any, row: number) => void;

    // this one will be injected by Container
    items: ServiceAccount[];
}

const getterLogin: Getter<ServiceAccount> = sa => sa.Username;
const getDivisionName: Getter<ServiceAccount> = sa => sa.Division;
const importIcon = <span className="glyphicon glyphicon-cloud-download" style={{verticalAlign: 'text-bottom'}} title="Import in progress. It can take a few minutes."/>;

export const ServiceAccountGrid = (props: ServiceAccountGridProps) => {
        const { polyglot } = props;
        return (
        <DataGrid initialData={props.items} className={props.className} onThead={props.onThead}>
            <MultiselectColumn {...multiselectPropsFrom(props)} />
            <IdColumn header={polyglot.t('column.id')}/>
            <DataGridTemplateColumn getValue={getterLogin}
                header={polyglot.t('service_account.label_username')} render={(colProps: TemplateProps) => {
                const sa = colProps.datum as ServiceAccount;            
                return <td>{ sa.OngoingAutoImport ? importIcon : null } {getterLogin(sa)}</td>
            }} />
            { props.isDivisionAware && <DataGridTextColumn header={polyglot.t('service_account.label_division')} getValue={getDivisionName} /> }
            { props.isAdmin && <DataGridButtonColumn header={polyglot.t('column.action')} title={polyglot.t('button.edit_short')} onClick={props.onEdit} /> }
        </DataGrid>
    )
};


// WEBPACK FOOTER //
// ./src/app/components/Pages/ServiceAccount/ServiceAccountGrid.tsx